import { render, staticRenderFns } from "./COSTable.vue?vue&type=template&id=7575c22c&scoped=true"
import script from "./COSTable.vue?vue&type=script&lang=js"
export * from "./COSTable.vue?vue&type=script&lang=js"
import style0 from "./COSTable.vue?vue&type=style&index=0&id=7575c22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7575c22c",
  null
  
)

export default component.exports